import React from 'react';

export const RomanInsideWindow = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.6 62.6" {...props}>
      <path fill="#fff" d="M4.879.534h85.7v60.7h-85.7z" />
      <path
        d="M90.579 61.834h-85.7c-.3 0-.6-.3-.6-.6V.534c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c0 .3-.3.6-.6.6zm-85.2-1.2h84.6v-59.5h-84.6v59.5z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M4.879.534h85.7v60.7h-85.7z" />
      <path
        d="M90.579 61.834h-85.7c-.3 0-.6-.3-.6-.6V.534c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c0 .3-.3.6-.6.6zm-85.2-1.2h84.6v-59.5h-84.6v59.5z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M8.879 4.534h77.7v52.7h-77.7z" />
        <path d="M86.579 57.834h-77.7c-.3 0-.6-.3-.6-.6v-52.7c0-.3.3-.6.6-.6h77.7c.3 0 .6.3.6.6v52.7c0 .3-.3.6-.6.6zm-77.2-1.2h76.6v-51.5h-76.6v51.5z" />
      </g>
      <path
        d="M94.879 61.734H.479c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h94.4c.3 0 .5.2.5.5.1.3-.2.5-.5.5z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M8.1 3.4h79v3.3h-79z" />
        <path
          d="M86.9 3.6v2.8H8.3V3.6h78.6m.4-.4H7.9V6.8h79.4V3.2z"
          fill="#fff"
        />
        <path fill="#233762" d="M8 36.2h79.2v1.7H8z" />
        <path d="M87 36.4v1.4H8.2v-1.4H87m.3-.3H7.8v2h79.5v-2z" fill="#fff" />
        <path fill="#233762" d="M8.1 6.9h79v2.7h-79z" />
        <path
          d="M86.9 7.1v2.3H8.3V7.1h78.6m.4-.5H7.9V9.7h79.4V6.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M8.1 12.6V9.9h79v2.7z" />
        <path
          d="M86.9 10.1v2.3H8.3v-2.3h78.6m.4-.4H7.8V12.8h79.4V9.7h.1z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M8.1 12.7h79v2.7h-79z" />
          <path
            d="M86.9 12.9v2.3H8.3v-2.3h78.6m.4-.4H7.9V15.6h79.4V12.5z"
            fill="#fff"
          />
          <g>
            <path fill="#233762" d="M8.1 18.4v-2.7h79v2.7z" />
            <path
              d="M86.9 16v2.3H8.3V16h78.6m.4-.5H7.8V18.6h79.4v-3.1h.1z"
              fill="#fff"
            />
          </g>
        </g>
        <g>
          <path fill="#233762" d="M8.1 18.6h79v2.7h-79z" />
          <path
            d="M86.9 18.8v2.3H8.3v-2.3h78.6m.4-.4H7.9V21.5h79.4V18.4z"
            fill="#fff"
          />
          <g>
            <path fill="#233762" d="M8.1 24.3v-2.7h79v2.7z" />
            <path
              d="M86.9 21.9v2.3H8.3v-2.3h78.6m.4-.5H7.8V24.5h79.4V21.4h.1z"
              fill="#fff"
            />
          </g>
        </g>
        <g>
          <path fill="#233762" d="M8.1 24.4h79v2.7h-79z" />
          <path
            d="M86.9 24.7V27H8.3v-2.3h78.6m.4-.5H7.9V27.3h79.4V24.2z"
            fill="#fff"
          />
          <g>
            <path fill="#233762" d="M8.1 30.2v-2.7h79v2.7z" />
            <path
              d="M86.9 27.7V30H8.3v-2.3h78.6m.4-.4H7.8V30.4h79.4V27.3h.1z"
              fill="#fff"
            />
          </g>
        </g>
        <g>
          <path fill="#233762" d="M8.1 30.2h79v2.7h-79z" />
          <path
            d="M86.9 30.4v2.3H8.3v-2.3h78.6m.4-.5H7.9V33h79.4V29.9z"
            fill="#fff"
          />
          <g>
            <path fill="#233762" d="M8.1 35.9v-2.7h79v2.7z" />
            <path
              d="M86.9 33.4v2.3H8.3v-2.3h78.6m.4-.4H7.8V36.1h79.4V33h.1z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      <g>
        <path fill="#fff" d="M5.6 1.7h85v60.1h-85z" />
        <path
          d="M90.6 62.6h-85c-.4 0-.7-.3-.7-.7V1.7c0-.4.4-.7.7-.7h85c.4 0 .7.3.7.7v60.1c0 .4-.3.8-.7.8zM6.3 61.2h83.6V2.4H6.3v58.8z"
          fill="#dcd9d5"
        />
        <path fill="#fff" d="M5.6 1.7h85v60.1h-85z" />
        <path
          d="M90.6 62.6h-85c-.4 0-.7-.3-.7-.7V1.7c0-.4.4-.7.7-.7h85c.4 0 .7.3.7.7v60.1c0 .4-.3.8-.7.8zM6.3 61.2h83.6V2.4H6.3v58.8z"
          fill="#dcd9d5"
        />
        <g fill="#dcd9d5">
          <path d="M9.6 5.7h77.1v52.2H9.6z" />
          <path d="M86.7 58.6H9.6c-.4 0-.7-.3-.7-.7V5.7c0-.4.3-.7.7-.7h77.1c.4 0 .7.3.7.7v52.2c-.1.4-.4.7-.7.7zm-76.4-1.4H86V6.4H10.3v50.8z" />
        </g>
        <path
          d="M94.9 62.5H1.3c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h93.6c.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"
          fill="#dcd9d5"
        />
        <g>
          <path fill="#233762" d="M8.3 4.6h79.4v3.7H8.3z" />
          <path d="M88.1 8.6H8V4.3h80.1v4.3zM8.7 8h78.7V5H8.7v3z" fill="#fff" />
          <path
            d="M8.6 19h78.7c-2.3-2.2-.6-8.7 0-10.4H8.7c-1.1 2.7-3 9.4-.1 10.4z"
            fill="#233762"
          />
          <g fill="#fff">
            <path d="M25.6 19.7h-.1c-.5-.2-1-.5-1.3-1-.1-.2-.1-.4.1-.5.2-.1.4-.1.5.1.2.3.5.6.9.7.2.1.3.3.2.4 0 .2-.1.3-.3.3zM24 17.5c-.2 0-.3-.1-.4-.3-.1-.5-.1-.9-.1-1.4 0-.2.2-.4.4-.4s.4.1.4.3c0 .4 0 .9.1 1.3 0 .3-.1.5-.4.5.1 0 .1 0 0 0zm0-2.7c-.2 0-.4-.2-.4-.4.1-.4.1-.9.2-1.4 0-.2.2-.3.4-.3s.3.2.3.4c-.1.5-.2.9-.2 1.3 0 .3-.1.4-.3.4zm.5-2.7s-.1 0 0 0c-.3-.1-.4-.2-.4-.4.1-.5.3-.9.4-1.3.1-.2.3-.3.5-.2.2.1.3.2.3.4-.1.4-.3.8-.4 1.3-.1.1-.2.2-.4.2zm.8-2.6h-.1c-.2-.1-.3-.3-.2-.5.4-1.1.4-1.1.7-1l-.1.7.1-.3h.3s-.1.3-.3.8c-.1.2-.2.3-.4.3zM70.6 19.7h-.1c-.5-.2-1-.5-1.3-1-.1-.2-.1-.4.1-.5.2-.1.4-.1.5.1.2.3.5.6.9.7.2.1.3.3.2.4 0 .2-.1.3-.3.3zM69 17.5c-.2 0-.3-.1-.4-.3-.1-.5-.1-.9-.1-1.4 0-.2.2-.4.4-.4s.4.1.4.3c0 .4 0 .9.1 1.3 0 .3-.1.5-.4.5.1 0 .1 0 0 0 .1 0 0 0 0 0zm0-2.7c-.2 0-.4-.2-.4-.4.1-.4.1-.9.2-1.4 0-.2.2-.3.4-.3s.3.2.3.4c-.1.5-.2.9-.2 1.3 0 .3-.1.4-.3.4zm.5-2.7c-.3-.1-.4-.2-.4-.4.1-.5.3-.9.4-1.3.1-.2.3-.3.5-.2.2.1.3.2.3.4-.1.4-.3.8-.4 1.3-.1.1-.2.2-.4.2zm.8-2.6h-.1c-.2-.1-.3-.3-.2-.5.4-1.1.4-1.1.7-1l-.1.7.1-.3h.3s-.1.3-.3.8c-.1.2-.2.3-.4.3z" />
          </g>
          <path
            d="M8.6 30h78.7c-2.3-2.2-.6-8.7 0-10.4H8.7c-1.1 2.7-3 9.4-.1 10.4z"
            fill="#233762"
          />
          <g fill="#fff">
            <path d="M25.6 30.6h-.1c-.5-.2-1-.5-1.3-1-.1-.2-.1-.4.1-.5.2-.1.4-.1.5.1.2.3.5.6.9.7.2.1.3.3.2.4 0 .3-.1.3-.3.3zM24 28.5c-.2 0-.3-.1-.4-.3-.1-.5-.1-.9-.1-1.4 0-.2.2-.4.4-.4s.4.1.4.3c0 .4 0 .9.1 1.3 0 .3-.1.5-.4.5zm0-2.7c-.2 0-.4-.2-.4-.4.1-.4.1-.9.2-1.4 0-.2.2-.3.4-.3s.3.2.3.4c-.1.5-.2.9-.2 1.3 0 .3-.1.4-.3.4zm.5-2.7s-.1 0 0 0c-.3-.1-.4-.2-.4-.4.1-.5.3-.9.4-1.3.1-.2.3-.3.5-.2.2.1.3.2.3.4-.1.4-.3.8-.4 1.3-.1.1-.2.2-.4.2zm.8-2.6h-.1c-.2-.1-.3-.3-.2-.5.2-.5.3-.8.3-.8.1-.1.2-.2.4-.2s.4.2.4.3v.1c0 .1-.1.3-.3.8-.2.2-.3.3-.5.3zM70.6 30.6h-.1c-.5-.2-1-.5-1.3-1-.1-.2-.1-.4.1-.5.2-.1.4-.1.5.1.2.3.5.6.9.7.2.1.3.3.2.4 0 .3-.1.3-.3.3zM69 28.5c-.2 0-.3-.1-.4-.3-.1-.5-.1-.9-.1-1.4 0-.2.2-.4.4-.4s.4.1.4.3c0 .4 0 .9.1 1.3 0 .3-.1.5-.4.5.1 0 0 0 0 0zm0-2.7c-.2 0-.4-.2-.4-.4.1-.4.1-.9.2-1.4 0-.2.2-.3.4-.3s.3.2.3.4c-.1.5-.2.9-.2 1.3 0 .3-.1.4-.3.4zm.5-2.7c-.3-.1-.4-.2-.4-.4.1-.5.3-.9.4-1.3.1-.2.3-.3.5-.2.2.1.3.2.3.4-.1.4-.3.8-.4 1.3-.1.1-.2.2-.4.2zm.8-2.6h-.1c-.2-.1-.3-.3-.2-.5.2-.5.3-.8.3-.8.1-.1.2-.2.4-.2s.4.2.4.3v.1c0 .1-.1.3-.3.8-.2.2-.3.3-.5.3z" />
          </g>
          <path
            d="M8.6 41h78.7c-2.3-2.2-.6-8.7 0-10.4H8.7c-1.1 2.7-3 9.4-.1 10.4z"
            fill="#233762"
          />
          <g fill="#fff">
            <path d="M25.6 41.6h-.1c-.5-.2-1-.5-1.3-1-.1-.2-.1-.4.1-.5.2-.1.4-.1.5.1.2.3.5.6.9.7.2.1.3.3.2.4 0 .2-.1.3-.3.3zM24 39.5c-.2 0-.3-.1-.4-.3-.1-.5-.1-.9-.1-1.4 0-.2.2-.4.4-.4s.4.1.4.3c0 .4 0 .9.1 1.3 0 .3-.1.5-.4.5zm0-2.7c-.2 0-.4-.2-.4-.4.1-.4.1-.9.2-1.4 0-.2.2-.3.4-.3s.3.2.3.4c-.1.5-.2.9-.2 1.3 0 .2-.1.4-.3.4zm.5-2.7s-.1 0 0 0c-.3-.1-.4-.2-.4-.4.1-.5.3-.9.4-1.3.1-.2.3-.3.5-.2.2.1.3.2.3.4-.1.4-.3.8-.4 1.3-.1.1-.2.2-.4.2zm.8-2.6h-.1c-.2-.1-.3-.3-.2-.5.2-.5.3-.8.3-.8.1-.2.3-.3.5-.2.2.1.3.3.2.4 0 0-.1.3-.3.8-.1.2-.2.3-.4.3zM70.6 41.6h-.1c-.5-.2-1-.5-1.3-1-.1-.2-.1-.4.1-.5.2-.1.4-.1.5.1.2.3.5.6.9.7.2.1.3.3.2.4 0 .2-.1.3-.3.3zM69 39.5c-.2 0-.3-.1-.4-.3-.1-.5-.1-.9-.1-1.4 0-.2.2-.4.4-.4s.4.1.4.3c0 .4 0 .9.1 1.3 0 .3-.1.5-.4.5.1 0 0 0 0 0zm0-2.7c-.2 0-.4-.2-.4-.4.1-.4.1-.9.2-1.4 0-.2.2-.3.4-.3s.3.2.3.4c-.1.5-.2.9-.2 1.3 0 .2-.1.4-.3.4zm.5-2.7c-.3-.1-.4-.2-.4-.4.1-.5.3-.9.4-1.3.1-.2.3-.3.5-.2.2.1.3.2.3.4-.1.4-.3.8-.4 1.3-.1.1-.2.2-.4.2zm.8-2.6h-.1c-.2-.1-.3-.3-.2-.5.2-.5.3-.8.3-.8.1-.2.3-.3.5-.2.2.1.3.3.2.4 0 0-.1.3-.3.8-.1.2-.2.3-.4.3z" />
          </g>
          <path
            d="M8.6 19l.2.6h78.6V19H8.6zM8.6 30l.2.6h78.6V30H8.6zM8.6 41l.2.6h78.6V41H8.6zM8.6 8l.2.6h78.6V8H8.6z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
